export default __webpack_public_path__ + "static/media/closeup.457beffc.jpg";